import { Dayjs } from "dayjs";
import { FilingReportItem } from "../../../api";

export type SortableColumn =
  | "caseName"
  | "taskName"
  | "practiceArea"
  | "createdAt"
  | "dueDate"
  | "caseTeam"
  | "status"
  | "statusHistory"
  | "note";

export type SortDirection = "asc" | "desc";

export type SortRule = {
  column: SortableColumn;
  direction: SortDirection;
};

export type FilingFiltersState = {
  caseName: string;
  taskName: string;
  practiceArea: string;
  status: string;
  overdue: string;
  createdFrom: Dayjs | null;
  createdTo: Dayjs | null;
  dueFrom: Dayjs | null;
  dueTo: Dayjs | null;
  searchTerm: string;
};

export type FilterFieldKey = Exclude<
  keyof FilingFiltersState,
  "createdFrom" | "createdTo" | "dueFrom" | "dueTo"
>;

export const STATUS_FILTER_NONE = "__none__";

export const EMPTY_FILTERS: FilingFiltersState = {
  caseName: "",
  taskName: "",
  practiceArea: "",
  status: "",
  overdue: "",
  createdFrom: null,
  createdTo: null,
  dueFrom: null,
  dueTo: null,
  searchTerm: "",
};

export const FILTER_FIELD_LABELS: Record<FilterFieldKey, string> = {
  caseName: "Case",
  taskName: "Task",
  practiceArea: "Practice Area",
  status: "Status",
  overdue: "Overdue",
  searchTerm: "Search",
};

export const OVERDUE_FILTER_OPTIONS = ["Yes", "No"] as const;

export const PRACTICE_AREA_OPTIONS = ["Arb", "LLO", "Lit", "PLO"] as const;

export const SORT_FIELD_OPTIONS: { value: SortableColumn; label: string }[] = [
  { value: "caseName", label: "Case Name" },
  { value: "taskName", label: "Task" },
  { value: "practiceArea", label: "Practice Area" },
  { value: "createdAt", label: "Created At" },
  { value: "dueDate", label: "Due Date" },
  { value: "caseTeam", label: "Case Team" },
  { value: "status", label: "Status" },
  { value: "statusHistory", label: "Status History" },
  { value: "note", label: "Note" },
];

export const SORT_DIRECTION_OPTIONS: { value: SortDirection; label: string }[] = [
  { value: "asc", label: "Ascending" },
  { value: "desc", label: "Descending" },
];

export const DEFAULT_SORT_RULES: SortRule[] = [{ column: "createdAt", direction: "desc" }];

export type HeadCell = {
  id: SortableColumn;
  label: string;
  widthPct: number;
};

export type FilingReportRow = FilingReportItem & {
  rowNumber?: number;
};
